(function () {
  const KEY = 'dby-popup-b-dismissed';
  
  if (sessionStorage.getItem(KEY)) return;

  const modalHTML = `
  <div class="dby-pb-overlay" id="dbyPopupBOverlay">
    <div class="dby-pb" id="dbyPopupB" role="dialog" aria-modal="true" aria-label="Showcase offer">
      <button class="pb-close" id="dbyPopupBClose" aria-label="Close">&times;</button>
      <div class="pb-brand">
        <svg class="pb-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 18L18 6M18 6H9M18 6V15" stroke="#2E46FA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>DevBehindYou</span>
      </div>
      <p class="pb-headline">This website is a showcase build.</p>
      <p class="pb-copy">Get the full source code, CRM, and SEO services — plus 5 free AI-SEO optimized blogs.</p>
      <a class="pb-cta" href="https://devbehindyou.vercel.app/contact" target="_blank" rel="noopener">
        <span class="pb-cap"></span>
        <span class="pb-body">
          <span class="pb-label">Free with every project</span>
          <span class="pb-title">5 AI-SEO Optimized Blogs</span>
        </span>
      </a>
    </div>
  </div>`;

  const div = document.createElement('div');
  div.innerHTML = modalHTML;
  document.body.appendChild(div.firstElementChild);

  const overlay = document.getElementById('dbyPopupBOverlay');
  const closeBtn = document.getElementById('dbyPopupBClose');
  let lastFocused = null;

  function show() {
    lastFocused = document.activeElement;
    overlay.classList.add('is-visible');
    closeBtn.focus();
  }

  function hide() {
    overlay.classList.remove('is-visible');
    sessionStorage.setItem(KEY, '1');
    if (lastFocused) lastFocused.focus();
  }

  setTimeout(show, 10000);

  closeBtn.addEventListener('click', hide);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) hide();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) hide();
  });
})();
